import { useEffect, useState } from "react";

const useIsMobileOS = () => {
  const [isMobileOS, setIsMobileOS] = useState(false);

  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    const isAndroid = /Android/i.test(userAgent);
    const isIOS =
      /iPad|iPhone|iPod/.test(userAgent) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
    setIsMobileOS(isAndroid || isIOS);
  }, []);

  return isMobileOS;
};

export default useIsMobileOS;
